module.exports = __webpack_public_path__ + "img/album19_03.fd93bc6d.jpg";